module.exports = __webpack_public_path__ + "static/banner-68b0b7fb2c37028bd6f6135dc2127600.jpg";